import type { ActionInput, Platform } from "./types";

export const ARENA_WIDTH = 1280;
export const ARENA_HEIGHT = 720;
export const TICK_RATE = 30;
export const FIXED_DELTA_SECONDS = 1 / TICK_RATE;

export const ROUND_TICKS = 75 * TICK_RATE;
export const COUNTDOWN_TICKS = 3 * TICK_RATE;
export const ROUND_END_TICKS = 2 * TICK_RATE;
export const ROUNDS_TO_WIN = 2;

export const DUEL_TARGET_SCORE = 3;
export const TEAM_TARGET_SCORE = 5;

export const PLAYER_HALF_WIDTH = 21;
export const PLAYER_HALF_HEIGHT = 28;
export const PLAYER_MOVE_SPEED = 240;
export const CAPTURE_MOVE_SPEED = PLAYER_MOVE_SPEED * 0.2;
export const JUMP_SPEED = 570;
export const GRAVITY = 1_650;
export const MAX_FALL_SPEED = 920;

export const PROJECTILE_SPEED = 560;
export const PROJECTILE_RADIUS = 13;
export const PROJECTILE_LIFETIME_TICKS = Math.ceil(0.95 * TICK_RATE);
export const PROJECTILE_SPAWN_OFFSET = PLAYER_HALF_WIDTH + 18;

export const CAPTURE_TICKS = Math.ceil(2.2 * TICK_RATE);
export const PRESSURE_CAPTURE_TICKS = Math.ceil(3.5 * TICK_RATE);
export const POP_LOCK_TICKS = Math.ceil(0.25 * TICK_RATE);
export const FIRE_COOLDOWN_TICKS = Math.ceil(0.65 * TICK_RATE);
export const PRESSURE_FIRE_COOLDOWN_TICKS = Math.ceil(0.45 * TICK_RATE);
export const RESPAWN_TICKS = Math.ceil(1.25 * TICK_RATE);
export const INVULNERABILITY_TICKS = 1 * TICK_RATE;
export const RESCUE_INVULNERABILITY_TICKS = Math.ceil(0.75 * TICK_RATE);
export const ESCAPE_INVULNERABILITY_TICKS = Math.ceil(0.5 * TICK_RATE);

export const OVERTIME_WALL_START_TICKS = 10 * TICK_RATE;
export const OVERTIME_MAX_PRESSURE_TICKS = 30 * TICK_RATE;
export const OVERTIME_WALL_SPEED_PER_TICK = 0.5;
export const MAX_WALL_INSET = 220;

export const EMPTY_INPUT: Readonly<ActionInput> = Object.freeze({
  move: 0,
  jump: false,
  drop: false,
  fire: false,
});

export const ARENA_PLATFORMS: ReadonlyArray<Readonly<Platform>> = Object.freeze([
  Object.freeze({
    id: "floor",
    x: 0,
    y: 660,
    width: ARENA_WIDTH,
    height: 60,
    oneWay: false,
  }),
  Object.freeze({
    id: "lower-left",
    x: 145,
    y: 525,
    width: 330,
    height: 22,
    oneWay: true,
  }),
  Object.freeze({
    id: "lower-right",
    x: 805,
    y: 525,
    width: 330,
    height: 22,
    oneWay: true,
  }),
  Object.freeze({
    id: "center",
    x: 490,
    y: 390,
    width: 300,
    height: 22,
    oneWay: true,
  }),
  Object.freeze({
    id: "upper-left",
    x: 235,
    y: 270,
    width: 230,
    height: 22,
    oneWay: true,
  }),
  Object.freeze({
    id: "upper-right",
    x: 815,
    y: 270,
    width: 230,
    height: 22,
    oneWay: true,
  }),
]);
